'use strict';

var $ = require('jquery');

var _ = require('underscore');

module.exports =  function (conf) {
    var $el = $(conf.query);
    $el.each(function () {
        _.extend(this, conf);
        if (typeof this.createdCallback === 'function') {
            this.createdCallback();
        }
        if (typeof this.attachedCallback === 'function') {
            this.attachedCallback();
        }
    });
    return $el;
};
